import chevronUpIcon from "@/assets/icons/ic-chevron-up.svg";
import chevronDownIcon from "@/assets/icons/ic-chevron-down.svg";
import closeIcon from "@/assets/icons/ic-x-close.svg";
import blurBg from "@/assets/images/bg-blur.png";

interface GuidelinePanelProps {
  expanded: boolean;
  onToggle: () => void;
}

const GUIDELINE_ITEMS = [
  "적용 업무 범위: 수행 업무와 제외 대상을 명확히 설정하여 모호성을 배제해 주세요.",
  "도입 목적: 에이전트 도입을 통해 달성하고자 하는 비즈니스 목표와 기대 효과를 명확히 정의해 주세요.",
  "자동화 수준 정의: 시스템의 자율 실행 범위와 인간(관리자)의 개입 여부를 구별해 주세요.",
  "보안 정책: 사내 보안 규정에 따른 망 분리 요건(폐쇄망 등) 및 LLM 구축 방식을 확정해 주세요.",
  "데이터 및 파이프라인 요건: 활용할 데이터의 종류(비정형/정형)와 정제 파이프라인 요건을 구체화해 주세요.",
];

export function GuidelinePanel({ expanded, onToggle }: GuidelinePanelProps) {
  return (
    <div className="relative flex flex-col">
      <button
        type="button"
        onClick={onToggle}
        className={`flex h-8 items-center gap-2 rounded-[4px]  px-3 py-2 ${expanded ? "bg-[#EBEBEB]" : ""}`}
      >
        <span className="text-base font-normal leading-6 tracking-[-0.01em] text-[#000000] underline">
          빠른 매칭 가이드
        </span>
        <img src={expanded ? chevronDownIcon : chevronUpIcon} alt="" className="h-5 w-5" />
      </button>

      {expanded && (
        <div className="absolute overflow-hidden lg:left-[-105px] bottom-full mt-2 mb-2 lg:mb-0 flex w-[290px] flex-col gap-2 rounded border border-black/[0.09] bg-white px-2 pb-2 pt-3 shadow-[0px_0px_24px_-4px_rgba(0,0,0,0.07)] lg:bottom-full lg:top-auto lg:mb-2 lg:mt-0 lg:w-[503px] lg:p-4">
          {/* <img
            src={blurBg}
            alt=""
            className="pointer-events-none absolute inset-0 h-full w-full object-cover"
          /> */}
          <div className="relative z-10 flex items-start justify-between">
            <div className="flex items-center gap-2">
              <span className="text-xs font-bold leading-4 text-black lg:block hidden">
                최적의 에이전트를 가장 빠르게 만날 수 있는 가이드라인
              </span>
              <span className="text-xs font-bold leading-4 text-black lg:hidden block ">
                최적의 에이전트를 가장 빠르게
                <br /> 만날 수 있는 가이드라인
              </span>
            </div>
            <button type="button" onClick={onToggle} className="shrink-0 lg:hidden">
              <img src={closeIcon} alt="Close" className="h-3 w-3" />
            </button>
          </div>
          <ul className="relative z-10 list-disc pl-[22px] text-xs leading-4 text-[#000000] lg:text-body-sm lg:leading-5 lg:tracking-[-0.01em]">
            {GUIDELINE_ITEMS.map((item) => (
              <li key={item.slice(0, 10)}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
